import axiosInstance from '../../config';
import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CurrencyFormat from 'react-currency-format';
import '../../styles/styles.css';
import { useHistory } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Navbar from '../../components/Navbar';
import moment from 'moment';
import Cash from '../../components/Cash';
import DepWd from '../../components/DepWd';
import CommWd from '../../components/CommWd';
import CreditLogM from '../member/functions/CreditLogM';
import BetList from '../../components/BetList';
import WegaBetList from '../../components/WegaBetList';
import BalanceGrandTotal from '../../components/BalanceGrandTotal';
import Details from './Details';
import AgentUtils from '../../agentutils';
import Pagination from '@material-ui/lab/Pagination';
import { toast } from 'react-toastify';

const useStyles = makeStyles((theme) => ({
  borderInactive: {
    backgroundColor: '#bfbfbf',
    '& td': {
      borderBottom: '1px solid black !important',
    },
  },
  borderSuspend: {
    backgroundColor: '#e1e1e1',
    '& td': {
      borderBottom: '1px solid black !important',
    },
  },
  border: {
    '& td': {
      borderBottom: '1px solid black !important',
    },
  },
  pointer: {
    cursor: 'pointer',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0.3rem 0',
  },
  Modal: {
    margin: '0 auto',
    width: '800px',
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  modalStyle: {
    position: 'absolute',
    top: '10%',
    left: '10%',
    overflowY: 'scroll',
    height: '80%',
    display: 'block',
    margin: 'auto',
  },
  tableBody: {
    '& td': {
      padding: '0.25rem 1rem  !important',
    },
  },
}));

// The columns are the union of every row's breakdown, in the order the response first shows them. The
// dictionary categories are the same list on every row, but a category that has since been retired
// still carries money on the members who used it: the backend appends those after the active ones and
// only on the rows that have them. Taking the column list from one row alone would drop such a column,
// and every other row's figure in it would go undrawn - so the figures would stop adding up.
const axisColumnsOf = (rows) => {
  const seen = {};
  const columns = [];
  for (let i = 0; i < rows.length; i++) {
    const lines = rows[i].wlByCategory || [];
    for (let j = 0; j < lines.length; j++) {
      if (!seen[lines[j].code]) {
        seen[lines[j].code] = true;
        columns.push(lines[j]);
      }
    }
  }
  return columns;
};

// Which figure of the axis a page reads. The axis is one column set with one figure per leg: the
// Net W/L report's lines carry the amount, the Comm report's carry the commission (the backend fills
// the leg the report is about and leaves the other figure off the line), and the column codes are the
// same on both. So the page picks its field once and every figure - cells, column set, totals - is read
// through it. Reading the wrong one would not show the other report's money: it would show a dash.
const AXIS_FIELD = { Comm: 'comm' };

// The catch-all (wega_categories OTHERS) is the one column that is not part of the fixed axis: it
// collects the rows whose bet carried no category at all, so on a day when nothing landed there it is
// a column of zeros that says nothing. Hide it then - and only it: a real category keeps its column
// even at zero, so the same figure can be read down the same column every day.
const hideWhenEmpty = (rows, column, field) =>
  column.code === 'OTHERS' &&
  rows.every((row) => (axisFigureOf(row, column.code, field) || 0) === 0);

// One member's figure for one category, on the leg this page reads. null (not 0) means the response
// carried no axis for that row, so the cell says so instead of showing a zero that would read as
// "no movement".
const axisFigureOf = (row, code, field) => {
  if (!row.wlByCategory) return null;
  const line = row.wlByCategory.find((category) => category.code === code);
  return line ? line[field] : 0;
};

// The member row's background, shared by both rows of the category view (design D2), so the two
// rows of one member cannot drift apart in colour.
const rowClassOf = (classes, info) =>
  `${
    info.status === true
      ? info.suspendAt
        ? classes.borderSuspend
        : classes.border
      : classes.borderInactive
  }`;

const WinLose = ({ User, type, opt }) => {
  const classes = useStyles();
  const [username, setUsername] = useState(null);
  const [cashModal, setCashModal] = useState(false);
  const [depositModal, setDepositModal] = useState(false);
  const [commModal, setCommModal] = useState(false);
  const [depositType, setDepositType] = useState(null);
  const [commType, setCommType] = useState(null);
  const [cashType, setCashType] = useState(false);
  const [selected, setSelected] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchDate, setSearchDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [reports, setReports] = useState([]);
  const [reports2, setReports2] = useState([]);
  // Summary = the report as it has always read. Category = the same table with the Net W/L column
  // broken down by the book each part was made on (design D1). It is a view of the same payload,
  // not a second report: the figures come from the wlByCategory the response already carries.
  const [reportView, setReportView] = useState('Summary');
  // Read synchronously when the report is fetched, because the fetch that follows a view change runs
  // before the state it was set from has re-rendered.
  const viewRef = useRef('Summary');
  const [detailUsername, setDetailUsername] = useState(null);
  const [details, setDetails] = useState([]);
  const [totalWl, setTotalWl] = useState(0);
  const [totalBeg, setTotalBeg] = useState(0);
  const [totalComm, setTotalComm] = useState(0);
  const [totalDep, setTotalDep] = useState(0);
  const [totalWd, setTotalWd] = useState(0);
  const [totalWo, setTotalWo] = useState(0);
  const [totalBal, setTotalBal] = useState(0);
  const [totalBalComm, setTotalBalComm] = useState(0);
  const [totalOutstanding, setTotalOutstanding] = useState(0);
  const [tab, setTab] = useState(0);
  const [bets, setBets] = useState([]); // outstanding
  // the net W/L modal holds two sources: the sports list below and the games rows behind the same
  // number, each with its own page and its own count
  const [wegaBets, setWegaBets] = useState([]);
  const [wegaTotalPage, setWegaTotalPage] = useState(null);
  const [wegaCount, setWegaCount] = useState(0);
  const [sportsCount, setSportsCount] = useState(0);
  const [netwlSegment, setNetwlSegment] = useState(0);
  // The column whose figure opened the Net W/L list. Null is the list as it has always opened (every
  // source, three segments); a column scopes it to the rows behind that one figure - see openColumnTickets.
  const [netwlScope, setNetwlScope] = useState(null);
  // The own sportsbook's wire token (a28dev WlCategoryDto.OWN_BOOK_CODE). It is on every axis response, and
  // it is the one "category" whose rows are the bets table's own rather than a WeGa category's.
  const OWN_BOOK_CODE = 'A28I';
  const categoryFilter =
    netwlScope && netwlScope.code !== OWN_BOOK_CODE ? netwlScope.code : null;
  // the period total behind the number, both sources and their sum, read once so it cannot move as
  // the segment changes
  const [grandTotal, setGrandTotal] = useState(null);
  const [wegaAmount, setWegaAmount] = useState(0);
  const [wegaTurnover, setWegaTurnover] = useState(0);
  const [wegaWinning, setWegaWinning] = useState(0);
  const [wegaComm, setWegaComm] = useState(0);
  // The WeGa sports population, read separately from the games one: these rows carry the sports columns and
  // belong to the sports number, but they are not in the bets table either, so neither sibling read lists
  // them. Its own segment, so a vendor whose sports activity is all WeGa does not read "Sports (0)".
  const [wegaSportBets, setWegaSportBets] = useState([]);
  const [wegaSportTotalPage, setWegaSportTotalPage] = useState(null);
  const [wegaSportCount, setWegaSportCount] = useState(0);
  const [wegaSportAmount, setWegaSportAmount] = useState(0);
  const [wegaSportTurnover, setWegaSportTurnover] = useState(0);
  const [wegaSportWinning, setWegaSportWinning] = useState(0);
  const [wegaSportComm, setWegaSportComm] = useState(0);
  const [transactionType, setTransactionType] = useState(null);
  const [transactions, setTransactions] = useState([]); // deposit/withdraw/netWL
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [totalPage, setTotalPage] = useState(null);
  const [playerWager, setPlayerWager] = useState(0);
  const [playerTurnover, setPlayerTurnover] = useState(0);
  const [playerComm, setPlayerComm] = useState(0);
  const [playerComm2, setPlayerComm2] = useState(0);
  const [playerWinning, setPlayerWinning] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [processing, setProcessing] = useState(false);
  const memberId = useRef('');
  const history = useHistory();

  const backToParent = () => {
    if (detailUsername != null) {
      setDetails([]);
      setDetailUsername(null);
    } else if (
      username != null &&
      username.length > 0 &&
      username !== sessionStorage.getItem('me')
    ) {
      if (username.length > 8) setUsername(username.substring(0, 8));
      else setUsername(username.substring(0, username.length - 2));
    }
  };

  const handleCredit = (usr, usrname) => {
    console.log(usrname.length);
    if (usrname.length > 8) {
      setTab(1);
    } else {
      setTab(2);
    }
  };

  const handleComm = (usr, usrname) => {
    console.log('comm cash log = ' + usrname.length);
    if (usrname.length > 8) {
      setTab(6);
    } else {
      setTab(7);
    }
  };

  const showMore = (e, value) => {
    if (e != null) e.preventDefault();
    axiosInstance
      .get('agent/balanceReport/' + transactionType, {
        params: {
          username: selected,
          transactionType: 1,
          startDate: startDate ? moment(startDate).format('DD-MM-YYYY') : null,
          endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
          pageNo: isNaN(value) ? null : value - 1,
        },
      })
      .then((res) => {
        let sumAmt = 0;
        for (let i = 0; i < res.data.content.length; i++) {
          sumAmt += res.data.content[i].amount;
        }
        // console.log(res.data.content);
        setTransactions(res.data.content);
        setTotalPage(res.data.totalPages);
        setTotalTransactions(sumAmt);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      });
  };

  const showNetwl = (e, value) => {
    if (e != null) e.preventDefault();
    axiosInstance
      .get('agent/balanceReport/netwl', {
        params: {
          username: selected,
          startDate: startDate ? moment(startDate).format('DD-MM-YYYY') : null,
          endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
          pageNo: isNaN(value) ? null : value - 1,
        },
      })
      .then((res) => {
        setBets(res.data.content);
        calculateBet(res.data.content);
        setTotalPage(res.data.totalPages);
        // the segment's own count comes off the same call - no third request for a label
        setSportsCount(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      });
  };

  // The WeGa sports rows behind the same number - the population that is sports-accounted and lives in
  // neither the bets table nor the games scope. A third read, on the endpoint the Report family already
  // lists this population with; it sets wc=true, so a vendor row's prefix scope works exactly as /netwl's
  // does, and it falls back to the caller when no member is named.
  const showNetwlWegaSport = (e, value) => {
    if (e != null) e.preventDefault();
    axiosInstance
      .get('agent/wlDetails/wegaSport', {
        params: {
          username: selected,
          startDate: startDate ? moment(startDate).format('DD-MM-YYYY') : null,
          endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
          wc: true,
          pageNo: isNaN(value) ? null : value - 1,
        },
      })
      .then((res) => {
        setWegaSportBets(res.data.content);
        setWegaSportCount(res.data.totalElements);
        setWegaSportTotalPage(res.data.totalPages);
        calculateWegaSport(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
        // a failed read must not leave the previous member's rows standing under this member's name
        setWegaSportBets([]);
        setWegaSportCount(0);
        setWegaSportTotalPage(null);
        calculateWegaSport([]);
      });
  };

  // The games rows behind the same number. A second call rather than one merged list: the two row
  // shapes share almost no columns, and each call carries its own count and page so neither segment
  // can be paged out of step with the other.
  const showNetwlGames = (e, value, category) => {
    if (e != null) e.preventDefault();
    // The code is the one the axis sent for the column that was clicked, and it is passed through exactly
    // as it arrived: the backend's filter is the axis's own grouping expression, so a code this screen
    // folded or trimmed would stop matching the column it came from (a28dev WegaBetRepository.CATEGORY_FILTER).
    // Paging calls this without a code, so the scope's own code is what a page 2 request carries.
    const code = category !== undefined ? category : categoryFilter;
    axiosInstance
      .get('agent/balanceReport/netwl/wega', {
        params: {
          username: selected,
          startDate: startDate ? moment(startDate).format('DD-MM-YYYY') : null,
          endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
          pageNo: isNaN(value) ? null : value - 1,
          category: code != null ? code : undefined,
        },
      })
      .then((res) => {
        setWegaBets(res.data.content);
        calculateWega(res.data.content);
        setWegaTotalPage(res.data.totalPages);
        setWegaCount(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      });
  };

  // The grand total behind the same number, both sources in one call: the figure the drill-down was
  // opened from is a period one, so the row that reconciles against it has to cover what it covers
  // whichever segment is open - sports as the W/L screens total it, the games rows the same way, and
  // the two together.
  const showBalanceGrandTotal = () => {
    axiosInstance
      .get('agent/balanceReport/grandTotal', {
        params: {
          username: selected,
          startDate: startDate ? moment(startDate).format('DD-MM-YYYY') : null,
          endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
          wc: true,
        },
      })
      .then((res) => {
        setGrandTotal(res.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      });
  };

  const showOutstanding = (e, value) => {
    if (e != null) e.preventDefault();
    axiosInstance
      .get('agent/balanceReport/outstanding', {
        params: {
          username: selected,
          pageNo: isNaN(value) ? null : value - 1,
        },
      })
      .then((res) => {
        setBets(res.data.content);
        calculateBet(res.data.content);
        setTotalPage(res.data.totalPages);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      });
  };

  const calculateBet = (report) => {
    let wager = 0,
      turnover = 0,
      comm = 0,
      comm2 = 0,
      winning = 0;
    for (var i = 0; i < report.length; i++) {
      wager += report[i].amount;
      turnover += report[i].turnover;
      comm += report[i].grossComm;
      comm2 += report[i].commission;
      if (report[i].winning) winning += report[i].winning;
    }
    setPlayerComm2(comm2);
    setPlayerWager(wager);
    setPlayerTurnover(turnover);
    setPlayerComm(comm);
    setPlayerWinning(winning + comm2);
  };

  // The games segment's footer, on the same basis the sports one uses (the rows on this page). A
  // games row carries the stake in amount and the turnover in validTurnover, so the two are summed
  // separately rather than assumed equal.
  const calculateWega = (report) => {
    let amount = 0,
      turnover = 0,
      winning = 0,
      comm = 0;
    for (let i = 0; i < report.length; i++) {
      amount += report[i].amount || 0;
      turnover += report[i].validTurnover || 0;
      if (report[i].winning) winning += report[i].winning;
      if (report[i].commission) comm += report[i].commission;
    }
    setWegaAmount(amount);
    setWegaTurnover(turnover);
    setWegaWinning(winning);
    setWegaComm(comm);
  };

  // The WeGa sports rows' own footer, on the same basis: the fields a WegaBetHistoryDto carries.
  const calculateWegaSport = (report) => {
    let amount = 0;
    let turnover = 0;
    let winning = 0;
    let comm = 0;
    for (let i = 0; i < report.length; i++) {
      amount += report[i].amount || 0;
      turnover += report[i].validTurnover || 0;
      if (report[i].winning) winning += report[i].winning;
      if (report[i].commission) comm += report[i].commission;
    }
    setWegaSportAmount(amount);
    setWegaSportTurnover(turnover);
    setWegaSportWinning(winning);
    setWegaSportComm(comm);
  };

  const getToday = (minus) => {
    axiosInstance.get('public/today').then((res) => {
      setStartDate(null);
      setEndDate(null);
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      today.setDate(today.getDate() - minus);
      setStartDate(today);
      setEndDate(today);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  };

  const getWeek = (minus) => {
    axiosInstance.get('public/today').then((res) => {
      setStartDate(null);
      setEndDate(null);
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let today2 = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let diff = today.getDay() - 1;
      if (diff < 0) diff += 7;
      today.setDate(today.getDate() - diff);
      if (minus > 0) {
        today.setTime(today.getTime() - minus * 7 * 24 * 60 * 60 * 1000);
        today2.setTime(today.getTime() + 6 * 24 * 60 * 60 * 1000);
      }
      setStartDate(today);
      setEndDate(today2);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  };

  const getMonth = (minus) => {
    axiosInstance.get('public/today').then((res) => {
      setStartDate(null);
      setEndDate(null);
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let today2 = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      if (minus > 0) {
        today.setMonth(today.getMonth() - minus);
        if (minus > 1) today2.setMonth(today2.getMonth() - minus + 1);
        today2.setDate(minus - 1);
      }
      today.setDate(1);
      setStartDate(today);
      setEndDate(today2);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  };

  const adjustAgent = (username) => {
    setProcessing(true);
    axiosInstance
      .get('agent/balReport/adjustAgent?username=' + username)
      .then((res) => {
        handleChange();
        console.log('success');
        toast.success('Success!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  const handleChange = (e, value) => {
    if (e != null) e.preventDefault();
    if (tab === 1 || tab === 2 || tab === 6 || tab === 7) {
      return;
    } else if (tab === 3) {
      showMore(null, 1);
      return;
    } else if (tab === 4) {
      showOutstanding(null, 1);
      return;
    } else if (tab === 5) {
      if (categoryFilter) {
        // opened from a category column: the games reader is the only source carrying that code, the
        // segment strip is not drawn to switch away from it, and the period total is not on this list
        // to refresh. Reading all three would reload the games list without the code as well, so the
        // re-searched list would stop being the rows behind the column.
        showNetwlGames(null, 1, categoryFilter);
        return;
      }
      showNetwl(null, 1);
      showNetwlGames(null, 1);
      showBalanceGrandTotal();
      return;
    }
    if (username != null && username.length > 8) return;
    if (detailUsername != null) {
      setReports([]);
      axiosInstance
        .get('agent/balanceReport/winLoseDetail', {
          params: {
            startDate: startDate
              ? moment(startDate).format('DD-MM-YYYY')
              : null,
            endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
            username: detailUsername,
            tx: type === 'Comm' ? false : true,
          },
        })
        .then((res) => {
          setDetails(res.data);
          let sumWl = 0,
            sumComm = 0,
            sumDep = 0,
            sumWd = 0,
            sumBal = 0,
            sumBalComm = 0,
            sumWo = 0,
            sumBeg = 0;
          for (let i = 0; i < res.data.length; i++) {
            sumWl += res.data[i].netWinLose;
            if (res.data[i].beginning) sumBeg += res.data[i].beginning;
            sumComm += res.data[i].winCommission;
            sumDep += res.data[i].deposit;
            sumWd += res.data[i].withdraw;
            sumBal += res.data[i].balance;
            sumWo += res.data[i].writeoff;
            sumBalComm +=
              res.data[i].beginning +
              res.data[i].winCommission -
              res.data[i].withdraw;
          }
          setTotalWo(sumWo);
          setTotalWl(sumWl);
          setTotalBeg(sumBeg);
          setTotalComm(sumComm);
          setTotalDep(sumDep);
          setTotalWd(sumWd);
          setTotalBal(sumBal);
          setTotalBalComm(sumBalComm);

        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            history.push('/');
          }
        });
    } else {
      setLoading(true);
      let wlUrl = 'agent/balanceReport/winLose';
      if (opt) {
        wlUrl += '2';
      }
      setReports([]);
      axiosInstance
        .get(wlUrl, {
          params: {
            startDate: startDate
              ? moment(startDate).format('DD-MM-YYYY')
              : null,
            endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
            agentUsername: username ? username : null,
            tx: type === 'Comm' ? false : true,
            // asked for only by the view that shows it: Summary is the report as it has always read,
            // and should not pay for a query and a payload it does not draw.
            withCategory: viewRef.current === 'Category',
            pageNo: isNaN(value) ? null : value - 1,
          },
        })
        .then((res) => {
          setReports(res.data.content);
          let sumWl = 0,
            sumComm = 0,
            sumDep = 0,
            sumWd = 0,
            sumBal = 0,
            sumBalComm = 0,
            sumOutstanding = 0,
            sumWo = 0,
            sumBeg = 0;
          for (let i = 0; i < res.data.content.length; i++) {
            if (res.data.content[i].beginning)
              sumBeg += res.data.content[i].beginning;
            sumWl += res.data.content[i].netWinLose;
            sumComm += res.data.content[i].winCommission;
            sumDep += res.data.content[i].deposit;
            sumWd += res.data.content[i].withdraw;
            if (res.data.content[i].writeoff)
              sumWo += res.data.content[i].writeoff;
            if (res.data.content[i].balance)
              sumBal += res.data.content[i].balance;
            if (res.data.content[i].outstanding)
              sumOutstanding += res.data.content[i].outstanding;
            sumBalComm +=
              res.data.content[i].beginning != null
                ? res.data.content[i].beginning +
                  res.data.content[i].winCommission +
                  res.data.content[i].withdraw
                : res.data.content[i].winCommission +
                  res.data.content[i].withdraw;
          }
          setTotalWo(sumWo);
          setTotalWl(sumWl);
          setTotalBeg(sumBeg);
          setTotalComm(sumComm);
          setTotalDep(sumDep);
          setTotalWd(sumWd);
          setTotalBal(sumBal);
          setTotalBalComm(sumBalComm);
          setTotalOutstanding(sumOutstanding);
          setTotalPage(res.data.totalPages);

          // if (User.agentType != null && User.agentType === 'COMPANY') {
          //   validateWL();
          // }
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            history.push('/');
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const validateReport = async () => {
    let url =
      'agent/balReport/consolidated?startDate=' +
      moment(startDate).format('DD-MM-YYYY') +
      '&endDate=' +
      moment(endDate).format('DD-MM-YYYY') +
      '&username=';

      const batchSize = 5;

      const processBatch = async (batch) => {
        return Promise.all(batch.map(async (report) => {
            axiosInstance
            .get(url + report.username)
            .then((res) => {
              let balance = res.data.balance;
              let comm = res.data.comm;
              let pl = res.data.reportWin + res.data.reportComm;
              console.log('sum1 = ' + balance.netWinLose);
              console.log('sum2 = ' + comm.winCommission);
              console.log('sum3 = ' + pl);
              document.getElementById('valid3' + balance.username).innerHTML = (
                pl +
                balance.netWinLose +
                comm.winCommission
              ).toFixed(2);
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                history.push('/');
              }
            })
        }));
      };

      for (let i = 0; i < reports.length; i += batchSize) {
        const batch = reports.slice(i, i + batchSize);
        await processBatch(batch);
      }
      setLoading(false);

    // https://api.amarchen.com/agent/balReport/consolidated?username=aa&startDate=12-09-2021&endDate=12-09-2021
  };

  const validateWL = () => {
    console.log('validate WL');
    if (type === 'Comm') return;
    let wlUrl = 'agent/balanceReport/winLose';
    if (opt) {
      wlUrl += '2';
    }
    setReports2([]);

    let validStartDate = new Date();
    let validEndDate = new Date();
    // console.log('startDate = '+startDate);
    if (startDate != null) {
      validEndDate.setTime(startDate.getTime() - 24 * 60 * 60000);
    }
    let diffTime = Math.abs(endDate - startDate);
    // console.log('diffTime = '+diffTime);
    if (diffTime > 1209600000) diffTime = 1209600000;
    if (diffTime < 604800000) diffTime = 604800000;
    // console.log('diffTime = '+diffTime);
    // console.log('endDate = '+endDate);
    // console.log('startDate = '+startDate);

    // let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // console.log('diffDays = '+diffDays);
    // console.log('d = '+(validEndDate.getDate() - diffDays));
    validStartDate.setTime(validEndDate.getTime() - diffTime);

    // console.log('validStartDate = '+moment(validStartDate).format('DD-MM-YYYY'));
    // console.log('validEndDate = '+moment(validEndDate).format('DD-MM-YYYY'));
    setLoading2(true);

    axiosInstance
      .get(wlUrl, {
        params: {
          startDate: validStartDate
            ? moment(validStartDate).format('DD-MM-YYYY')
            : null,
          endDate: validEndDate
            ? moment(validEndDate).format('DD-MM-YYYY')
            : null,
          agentUsername: username ? username : null,
          tx: type === 'Comm' ? false : true,
        },
      })
      .then((res) => {
        setReports2(res.data.content);
        for (var i = 0; i < res.data.content.length; i++) {
          var num = parseFloat(
            document.getElementById('valid' + res.data.content[i].username)
              .innerText
          ).toFixed(2);
          // console.log(
          //   'num = '+parseFloat(document.getElementById('valid'+res.data.content[i].username).innerText).toFixed(2)
          // );
          if (num == res.data.content[i].balance.toFixed(2)) {
            document.getElementById(
              'valid2' + res.data.content[i].username
            ).innerHTML = '<font><strong>Valid</strong></font>';
          } else {
            document.getElementById(
              'valid2' + res.data.content[i].username
            ).innerHTML =
              '<font color="red"><strong>' +
              res.data.content[i].balance +
              ',' +
              document.getElementById('valid' + res.data.content[i].username)
                .innerText +
              '</strong></font>';
            // console.log('pf = '+document.getElementById('valid'+res.data.content[i].username).innerHTML);
            // console.log('bal = '+res.data.content[i].balance);
          }
        }
        // console.log(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      })
      .finally(() => {
        setLoading2(false);
      });
  };

  useEffect(() => {
    if (startDate != null && endDate != null) handleChange(null);
  }, [username, startDate, endDate, detailUsername]);

  /**
   * Opens the Net W/L list for one member from one category column: the same list the total opens, with the
   * rows behind that column already selected. A WeGa column reads the games reader narrowed by the code; the
   * own book's column is not a WeGa category at all, so it opens the bets list it has always opened.
   */
  const openColumnTickets = (member, column) => {
    setSelected(member);
    setNetwlScope(column);
    setNetwlSegment(column.code === OWN_BOOK_CODE ? 0 : 2);
    setTab(5);
  };

  useEffect(() => {
    if (tab === 3) {
      showMore(null, 1);
    } else if (tab === 4) {
      showOutstanding(null, 1);
    } else if (tab === 5 && categoryFilter) {
      // Opened from a category figure: the rows behind that one column, and nothing else. The other two
      // sources are not read at all - their segments would offer lists that are not the rows behind it.
      setBets([]);
      setSportsCount(0);
      setWegaSportBets([]);
      setWegaSportCount(0);
      showNetwlGames(null, 1, categoryFilter);
      setNetwlSegment(2);
    } else if (tab === 5) {
      // every source loads together so each segment is labelled with its own count on the first paint
      showNetwl(null, 1);
      showNetwlWegaSport(null, 1);
      showNetwlGames(null, 1);
      showBalanceGrandTotal();
      setNetwlSegment(0);
    } else if (tab === 0) {
      handleChange(null);
    } else {
      setTransactions([]);
      setBets([]);
      setWegaBets([]);
    }
  }, [tab, netwlScope]);

  // A member whose activity is games, or WeGa sports, has nothing in the Sports segment - and the link that
  // opened this modal is the only way to the rows behind the number. So open the first segment that has
  // rows, in the order the block above lists them.
  useEffect(() => {
    if (tab !== 5 || netwlScope) return; // a column click already said which list it is
    if (sportsCount === 0) {
      if (wegaSportCount > 0) setNetwlSegment(1);
      else if (wegaCount > 0) setNetwlSegment(2);
    }
  }, [tab, sportsCount, wegaSportCount, wegaCount]);

  useEffect(() => {
    let usr = User.username;
    if (usr.indexOf('@') == -1) setUsername(usr);
    else {
      setUsername(usr.split('@')[1]);
    }
    axiosInstance.get('public/today').then((res) => {
      if (startDate == null)
        setStartDate(
          new Date(
            res.data.substring(6),
            parseInt(res.data.substr(3, 2)) - 1,
            res.data.substring(0, 2)
          )
        );
      if (endDate == null)
        setEndDate(
          new Date(
            res.data.substring(6),
            parseInt(res.data.substr(3, 2)) - 1,
            res.data.substring(0, 2)
          )
        );
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  }, [history.location]);

  // UI component
  const renderDateSearch = (retBtn, viewSelector) => {
    return (
      <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
        <form action="" onSubmit={(e) => e.preventDefault()} id="form">
          Start Date:
          <DatePicker
            selected={startDate ? startDate : new Date()}
            minDate={searchDate}
            onChange={(date) => setStartDate(date)}
            className="mx-1"
            dateFormat="d MMM yyyy"
          />
          End Date:
          <DatePicker
            selected={endDate ? endDate : new Date()}
            onChange={(date) => setEndDate(date)}
            className="mx-1"
            dateFormat="d MMM yyyy"
            minDate={startDate}
            maxDate={maxDate}
          />
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              handleChange(null);
            }}
          >
            Get Report
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getToday(0);
            }}
          >
            Today
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getToday(1);
            }}
          >
            Yesterday
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getWeek(0);
            }}
          >
            This Week
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getWeek(1);
            }}
          >
            Last Week
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getMonth(0);
            }}
          >
            This Month
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getMonth(1);
            }}
          >
            Last Month
          </button>{' '}
          {User.agentType != null && User.agentType === 'COMPANY' ? (
            <>
              <button
                className="btn btn-sm btn-danger px-3 py-1"
                onClick={() => {
                  validateReport();
                  validateWL();
                }}
              >
                Validate
              </button>{' '}
            </>
          ) : null}
          {viewSelector ? (
            <>
              <label className="mb-0 mx-1">View:</label>
              <select
                className="form-control form-control-sm d-inline-block mx-1"
                style={{ width: 'auto' }}
                value={reportView}
                onChange={(e) => {
                  viewRef.current = e.target.value;
                  setReportView(e.target.value);
                  handleChange(null);
                }}
                title="Summary is the report as it has always read. Category splits each member's Net W/L into the book each part was made on."
              >
                <option value="Summary">Summary</option>
                <option value="Category">Category</option>
              </select>
            </>
          ) : null}
          {retBtn ? (
            <button
              className="btn btn-sm btn-secondary px-3 py-1"
              onClick={() => {
                tab === 0 ? backToParent() : setTab(0);
              }}
            >
              Return
            </button>
          ) : null}
          {loading ? (
            <>
              <br />
              <img
                src={require('../../img/loadingAnimation.gif')}
                height={13}
                width={208}
                alt=""
              />
            </>
          ) : null}
          {loading2 ? (
            <>
              <br />
              <img
                src={require('../../img/loadingAnimation.gif')}
                height={13}
                width={208}
                alt=""
              />
            </>
          ) : null}
        </form>
      </div>
    );
  };

  // The Category view: the member table with the money column broken into one column per book it was
  // made on, plus a Total column holding the same figure that column held - Net W/L on the balance
  // report, Commission on the gross comm report (the same axis, read off the leg the page is about).
  // The breakdown is read off the response, so the screen holds no second copy of the dictionary.
  const categoryView = reportView === 'Category' && detailUsername == null;
  const axisField = AXIS_FIELD[type] || 'amount';
  const axisColumns = categoryView ? axisColumnsOf(reports) : [];
  const axisShown = axisColumns.filter((column) => !hideWhenEmpty(reports, column, axisField));
  const showAxis = categoryView && axisShown.length > 0;
  const axisTotal = (code) =>
    reports.reduce((sum, row) => sum + (axisFigureOf(row, code, axisField) || 0), 0);

  // Drawn once for whichever report is on screen, because the two are the same table: the balance
  // report's Net W/L column and the gross comm report's Commission column are the same axis. Only the
  // field differs, so the pages cannot drift apart.
  const renderAxisHeaders = () =>
    axisShown.map((column) => (
      <th scope="col" key={column.code}>
        {column.name}
      </th>
    ));

  const renderAxisCells = (info) =>
    showAxis
      ? axisShown.map((column) => {
          const figure = axisFigureOf(info, column.code, axisField);
          return (
            <td
              key={column.code}
              className={`${figure < 0 ? 'text-danger ' : ''}text-right`}
              style={{ minWidth: '84px' }}
            >
              {figure == null ? (
                <span className="text-muted">-</span>
              ) : (
                <a
                  className={`${classes.pointer} p-0 ${
                    figure < 0 ? 'text-danger ' : 'text-primary'
                  }`}
                  title={`The tickets behind ${column.name}`}
                  onClick={() => openColumnTickets(info.username, column)}
                >
                  <u>
                    <CurrencyFormat
                      value={figure}
                      decimalScale={2}
                      displayType={'text'}
                      thousandSeparator={true}
                      fixedDecimalScale={true}
                    />
                  </u>
                </a>
              )}
            </td>
          );
        })
      : null;

  const renderAxisTotals = () =>
    showAxis
      ? axisShown.map((column) => (
          <td
            key={column.code}
            className={`${axisTotal(column.code) < 0 ? 'text-danger ' : ''}text-right`}
          >
            <CurrencyFormat
              value={axisTotal(column.code)}
              decimalScale={2}
              displayType={'text'}
              thousandSeparator={true}
              fixedDecimalScale={true}
            />
          </td>
        ))
      : null;
  const reportColumns = type !== 'Comm' ? 13 : 9;
  const axisColumnCount = showAxis
    ? reportColumns - 1 + axisShown.length + 1
    : reportColumns;

  return (
    <>
      <Navbar User={User} />
      {!processing && (
        <>
          {tab === 0 ? (
            <>
              {renderDateSearch(
                detailUsername != null ||
                  (username != null &&
                    username.length > 0 &&
                    username !== sessionStorage.getItem('me') &&
                    !sessionStorage.getItem('me').endsWith(username)),
                detailUsername == null
              )}
              {/* {detailUsername != null ||
          (username != null &&
            username.length > 0 &&
            username !== sessionStorage.getItem('me') &&
            !sessionStorage.getItem('me').endsWith(username)) ? (
            <button
              className="btn btn-sm btn-secondary px-3 py-1 mx-1"
              onClick={() => {
                backToParent();
              }}
            >
              Return
            </button>
          ) : null} */}
              {detailUsername == null ? (
                <div className="table-responsive-sm mx-2">
                  <table className="table table-sm table-hover table-bordered">
                    <thead className="text-center thead-dark">
                      <tr>
                        <th colSpan={axisColumnCount}>
                          {username
                            ? ' ' + username
                            : ' ' + sessionStorage.getItem('me')}{' '}
                          {AgentUtils.getDownLevel(
                            username != null && username.length > 0
                              ? username
                              : sessionStorage.getItem('me')
                          )}{' '}
                          {type !== 'Comm' ? 'Balance' : 'Gross Comm'} Report [
                          {moment(startDate).format('DD/MMM/YYYY') +
                            ' - ' +
                            moment(endDate).format('DD/MMM/YYYY')}
                          ]
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Login ID</th>
                        <th scope="col">Currency</th>
                        <th scope="col">Beginning</th>
                        {type !== 'Comm' ? (
                          <>
                            {showAxis ? (
                              <>
                                {renderAxisHeaders()}
                                <th scope="col">Total</th>
                              </>
                            ) : (
                              <th scope="col">Net W/L</th>
                            )}
                            <th scope="col">Deposit</th>
                            <th scope="col">Withdraw</th>
                            {/* {username != null && username.length === 8? (
                          <th scope="col">Adjustment</th>
                        ) : null} */}
                            <th scope="col">Balance</th>
                          </>
                        ) : (
                          <>
                            {showAxis ? (
                              <>
                                {renderAxisHeaders()}
                                <th scope="col">Total</th>
                              </>
                            ) : (
                              <th scope="col">Commission</th>
                            )}
                            <th scope="col">Withdraw</th>
                            <th scope="col">Balance</th>
                          </>
                        )}

                        <th scope="col">Status</th>
                        <th scope="col">Function</th>
                        {type !== 'Comm' ? (
                          <th scope="col">Outstanding</th>
                        ) : null}
                        {User.agentType != null &&
                        User.agentType === 'COMPANY' &&
                        type !== 'Comm' ? (
                          <>
                            <th scope="col">Valid Beginning</th>
                            <th scope="col">Valid Report</th>
                          </>
                        ) : null}
                      </tr>
                    </thead>
                    {reports.length > 0 ? (
                      <tbody>
                        {reports.map((info, index) => (
                          <tr className={rowClassOf(classes, info)} key={index}>
                            {/* <tr key={index}> */}
                            <td className="text-dark text-left">
                              {info.name}&nbsp;&nbsp;
                              {User.agentType != null &&
                              User.agentType === 'COMPANY'
                                ? [
                                    <button
                                      className={`${classes.pointer} text-primary p-0 btn-link btn`}
                                      disabled={processing}
                                      onClick={() => {
                                        adjustAgent(info.username);
                                      }}
                                    >
                                      Adjust
                                    </button>,
                                  ]
                                : null}
                            </td>
                            <td className="text-dark text-center">
                              {(info.username.length > 8 && type !== 'Comm') ||
                              (info.username.length === 8 &&
                                type === 'Comm') ? (
                                info.username
                              ) : (
                                <a
                                  className={`${classes.pointer} text-primary p-0`}
                                  onClick={() => {
                                    memberId.current = info.id;
                                    setUsername(info.username);
                                  }}
                                >
                                  {info.username}
                                </a>
                              )}
                            </td>
                            <td className="text-dark text-center">
                              {info.currency}
                            </td>

                            {type !== 'Comm' ? (
                              <>
                                <td
                                  className={`${
                                    info.beginning < 0 ? 'text-danger ' : ''
                                  }text-right`}
                                >
                                  <CurrencyFormat
                                    value={info.beginning ? info.beginning.toFixed(2) : 0}
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                </td>
                                {renderAxisCells(info)}
                                <td
                                  className={`${
                                    info.netWinLose < 0 ? 'text-danger ' : ''
                                  }text-right`}
                                >
                                  {/* Always a link, including for a games-only member: the modal behind it
                                      carries both sources as segments (Sports / Games), so a row with no
                                      sports bets still opens the games it was paid on. Gating this on
                                      countBet hid the link exactly where it was the only way to reach the
                                      rows behind the number - and a games-only row is that case. */}
                                  <a
                                    className={`${classes.pointer} p-0 ${
                                      info.netWinLose < 0
                                        ? 'text-danger '
                                        : 'text-primary'
                                    }`}
                                    onClick={() => {
                                      setSelected(info.username);
                                      setNetwlScope(null); // the total is every source, as it always was
                                      setTab(5);
                                    }}
                                  >
                                    <u>
                                      <CurrencyFormat
                                        value={
                                          info.netWinLose
                                            ? info.netWinLose.toFixed(2)
                                            : 0
                                        }
                                        decimalScale={2}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        fixedDecimalScale={true}
                                      />
                                    </u>
                                  </a>
                                </td>
                                <td className="text-right">
                                  {info.deposit === 0 ? (
                                    '0.00'
                                  ) : (
                                    <a href="#" 
                                      className={`p-0 ${
                                        info.deposit < 0
                                          ? 'text-danger '
                                          : 'text-primary'
                                      }`}
                                      onClick={() => {
                                        setSelected(info.username);
                                        setTransactionType('deposits');
                                        setTab(3);
                                      }}
                                    >
                                      <u>
                                        <CurrencyFormat
                                          value={
                                            info.deposit ? info.deposit : 0
                                          }
                                          decimalScale={2}
                                          displayType={'text'}
                                          thousandSeparator={true}
                                          fixedDecimalScale={true}
                                        />
                                      </u>
                                    </a>
                                  )}
                                </td>
                                {/* <td
                            className={`${
                              info.deposit < 0 ? 'text-danger ' : ''
                            }text-right`}
                          >
                            <CurrencyFormat
                              value={info.deposit ? info.deposit : 0}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </td> */}
                                <td className="text-right">
                                  {info.withdraw === 0 ? (
                                    '0.00'
                                  ) : (
                                    <a href="#" 
                                      className={`p-0 ${
                                        info.withdraw < 0
                                          ? 'text-danger '
                                          : 'text-primary'
                                      }`}
                                      onClick={() => {
                                        setSelected(info.username);
                                        setTransactionType('withdraws');
                                        setTab(3);
                                      }}
                                    >
                                      <u>
                                        <CurrencyFormat
                                          value={
                                            info.withdraw ? info.withdraw : 0
                                          }
                                          decimalScale={2}
                                          displayType={'text'}
                                          thousandSeparator={true}
                                          fixedDecimalScale={true}
                                        />
                                      </u>
                                    </a>
                                  )}
                                </td>
                                {/* {username != null && username.length === 8 ? (
                              <td className="text-right">
                                {info.writeoff === 0 ? (
                                  '0.00'
                                ) : (
                                  <CurrencyFormat
                                    value={info.writeoff ? info.writeoff : 0}
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    className={info.writeoff < 0? 'text-danger' : null}
                                  />
                                )}
                              </td>
                            ) : null} */}
                                {/* <td
                            className={`${
                              info.withdraw < 0 ? 'text-danger ' : ''
                            }text-right`}
                          >
                            <CurrencyFormat
                              value={info.withdraw ? info.withdraw : 0}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </td> */}
                                <td
                                  className={`${
                                    info.balance < 0 ? 'text-danger ' : ''
                                  }text-right`}
                                >
                                  <CurrencyFormat
                                    value={
                                      info.balance != null
                                        ? info.balance.toFixed(2)
                                        : 0
                                    }
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                </td>
                              </>
                            ) : (
                              <>
                                <td
                                  className={`${
                                    info.beginning < 0 ? 'text-danger ' : ''
                                  }text-right`}
                                >
                                  <CurrencyFormat
                                    value={info.beginning ? info.beginning : 0}
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                </td>
                                {renderAxisCells(info)}
                                <td
                                  className={`${
                                    info.winCommission < 0 ? 'text-danger ' : ''
                                  }text-right`}
                                >
                                  <CurrencyFormat
                                    value={
                                      info.winCommission
                                        ? info.winCommission
                                        : 0
                                    }
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                </td>
                                <td className="text-right">
                                  {info.withdraw === 0 ? (
                                    '0.00'
                                  ) : (
                                    <a href="#" 
                                      className={`p-0 ${
                                        info.withdraw < 0
                                          ? 'text-danger '
                                          : 'text-primary'
                                      }`}
                                      onClick={() => {
                                        setSelected(info.username);
                                        setTransactionType('comms');
                                        setTab(3);
                                      }}
                                    >
                                      <u>
                                        <CurrencyFormat
                                          value={
                                            info.withdraw ? info.withdraw : 0
                                          }
                                          decimalScale={2}
                                          displayType={'text'}
                                          thousandSeparator={true}
                                          fixedDecimalScale={true}
                                        />
                                      </u>
                                    </a>
                                  )}
                                </td>
                                {/* <td
                            className={`${
                              info.withdraw < 0 ? 'text-danger ' : ''
                            }text-right`}
                          >
                            <CurrencyFormat
                              value={info.withdraw ? info.withdraw : 0}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </td> */}
                                <td
                                  className={`${
                                    info.beginning +
                                      info.winCommission +
                                      info.withdraw <
                                    0
                                      ? 'text-danger '
                                      : ''
                                  }text-right`}
                                >
                                  <CurrencyFormat
                                    value={
                                      info.beginning +
                                      info.winCommission +
                                      info.withdraw
                                        ? info.beginning +
                                          info.winCommission +
                                          info.withdraw
                                        : 0
                                    }
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                </td>
                              </>
                            )}

                            {info.status === true ? (
                              info.suspendAt ? (
                                <td className="text-danger text-center">
                                  Suspended
                                </td>
                              ) : (
                                <td className="text-dark text-center">
                                  Active
                                </td>
                              )
                            ) : (
                              <td className="text-danger text-center">
                                InActive
                              </td>
                            )}
                            <td>
                              {type !== 'Comm' ? (
                                <>
                                  {info.username.length <= 8 ? (
                                    <>
                                      <button
                                        className="btn btn-sm btn-link text-primary p-0"
                                        onClick={() => {
                                          setDetailUsername(info.username);
                                          // viewDetail(info.username);
                                        }}
                                      >
                                        Detail
                                      </button>
                                      &nbsp;|&nbsp;
                                      {User.privBalReport == null ||
                                      (User.privBalReport === true &&
                                        User.privBalReportDw === true) ? (
                                        <>
                                          <button
                                            className="btn btn-sm btn-link text-primary p-0"
                                            onClick={() => {
                                              setSelected(info.username);
                                              setCashType('Cash Out');
                                              setCashModal(true);
                                            }}
                                          >
                                            Deposit
                                          </button>
                                          &nbsp;|&nbsp;
                                          <button
                                            className="btn btn-sm btn-link text-primary p-0"
                                            onClick={() => {
                                              setSelected(info.username);
                                              setCashType('Cash In');
                                              setCashModal(true);
                                            }}
                                          >
                                            Withdraw
                                          </button>
                                          &nbsp;|&nbsp;
                                        </>
                                      ) : null}
                                    </>
                                  ) : User.privBalReport == null ||
                                    (User.privBalReport === true &&
                                      User.privBalReportDw === true) ? (
                                    <>
                                      <button
                                        className="btn btn-sm btn-link text-primary p-0"
                                        onClick={() => {
                                          setSelected(info.username);
                                          setDepositType('DEPOSIT');
                                          setDepositModal(true);
                                        }}
                                      >
                                        Deposit
                                      </button>
                                      &nbsp;|&nbsp;
                                      <button
                                        className="btn btn-sm btn-link text-primary p-0"
                                        onClick={() => {
                                          setSelected(info.username);
                                          setDepositType('WITHDRAW');
                                          setDepositModal(true);
                                        }}
                                      >
                                        Withdraw
                                      </button>
                                      &nbsp;|&nbsp;
                                    </>
                                  ) : null}
                                  <button
                                    className="btn btn-sm btn-link text-primary p-0"
                                    onClick={() => {
                                      memberId.current = info.id;
                                      handleCredit(info.id, info.username);
                                    }}
                                  >
                                    Cash log
                                  </button>
                                </>
                              ) : (
                                // gross comm
                                <>
                                  {info.username.length <= 8 ? (
                                    <>
                                      <button
                                        className="btn btn-sm btn-link text-primary p-0"
                                        onClick={() => {
                                          setDetailUsername(info.username);
                                        }}
                                      >
                                        Detail
                                      </button>
                                      &nbsp;|&nbsp;
                                      {User.privBalReport == null ||
                                      (User.privBalReport === true &&
                                        User.privBalReportDw === true) ? (
                                        <>
                                          <button
                                            className="btn btn-sm btn-link text-primary p-0"
                                            onClick={() => {
                                              setSelected(info.username);
                                              setCommType('TRANSFER_COMM');
                                              setCommModal(true);
                                            }}
                                          >
                                            Transfer
                                          </button>
                                          &nbsp;|&nbsp;
                                          <button
                                            className="btn btn-sm btn-link text-primary p-0"
                                            onClick={() => {
                                              setSelected(info.username);
                                              setCommType('WITHDRAW_COMM');
                                              setCommModal(true);
                                            }}
                                          >
                                            Withdraw
                                          </button>
                                          &nbsp;|&nbsp;
                                        </>
                                      ) : null}
                                    </>
                                  ) : User.privBalReport == null ||
                                    (User.privBalReport === true &&
                                      User.privBalReportDw === true) ? (
                                    <>
                                      <button
                                        className="btn btn-sm btn-link text-primary p-0"
                                        onClick={() => {
                                          setSelected(info.username);
                                          setCommType('TRANSFER_COMM');
                                          setCommModal(true);
                                        }}
                                      >
                                        Transfer
                                      </button>
                                      &nbsp;|&nbsp;
                                      <button
                                        className="btn btn-sm btn-link text-primary p-0"
                                        onClick={() => {
                                          setSelected(info.username);
                                          setCommType('WITHDRAW_COMM');
                                          setCommModal(true);
                                        }}
                                      >
                                        Withdraw
                                      </button>
                                      &nbsp;|&nbsp;
                                    </>
                                  ) : null}
                                  <button
                                    className="btn btn-sm btn-link text-primary p-0"
                                    onClick={() => {
                                      memberId.current = info.id;
                                      handleComm(info.id, info.username);
                                    }}
                                  >
                                    Cash log
                                  </button>
                                </>
                              )}
                            </td>
                            {type !== 'Comm' ? (
                              <td className="text-right">
                                {info.countOutstanding === 0 ? (
                                  '0.00'
                                ) : (
                                  <a href="#" 
                                    className={`p-0 ${
                                      info.outstanding < 0
                                        ? 'text-danger '
                                        : 'text-primary'
                                    }`}
                                    onClick={() => {
                                      setSelected(info.username);
                                      // setOutModal(true);
                                      setTab(4);
                                    }}
                                  >
                                    <u>
                                      <CurrencyFormat
                                        value={
                                          info.outstanding
                                            ? info.outstanding
                                            : 0
                                        }
                                        decimalScale={2}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        fixedDecimalScale={true}
                                      />
                                    </u>
                                  </a>
                                )}
                              </td>
                            ) : null}
                            {User.agentType != null &&
                            User.agentType === 'COMPANY' &&
                            type !== 'Comm' ? (
                              <>
                                <td align="center">
                                  <span
                                    id={`valid${info.username}`}
                                    className="display-hidden"
                                  >
                                    {info.beginning}
                                  </span>
                                  <span id={`valid2${info.username}`}></span>
                                </td>
                                <td align="center">
                                  <span id={`valid3${info.username}`}></span>
                                </td>
                              </>
                            ) : null}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                    {reports.length > 0 ? (
                      <tfoot>
                        <tr>
                          <td className="text-dark text-center" colSpan="3">
                            Total
                          </td>
                          {type !== 'Comm' ? (
                            <>
                              <td
                                className={`${
                                  totalBeg < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalBeg.toFixed(2)}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              {renderAxisTotals()}
                              <td
                                className={`${
                                  totalWl < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalWl}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  totalDep < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalDep}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  totalWd < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalWd}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              {/* { username != null && username.length === 8? (
                        <td
                          className={`${
                            totalWo < 0 ? 'text-danger ' : ''
                          }text-right`}
                        >
                          <CurrencyFormat
                            value={totalWo}
                            decimalScale={2}
                            displayType={'text'}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                          />
                        </td>
                        ) : null } */}
                              <td
                                className={`${
                                  totalBal < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalBal.toFixed(2)}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className="text-dark text-center"
                                colSpan="2"
                              ></td>
                              <td
                                className={`${
                                  totalOutstanding < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalOutstanding}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                className={`${
                                  totalBeg < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalBeg.toFixed(2)}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              {renderAxisTotals()}
                              <td
                                className={`${
                                  totalComm < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalComm}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  totalWd < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalWd}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  totalBalComm < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={totalBalComm}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              {/* Status and Function - two columns, which is what the Comm table's own
                                  header and rows carry. It read 3, one column wider than the table it
                                  closes, so the footer ran a column past the body. */}
                              <td
                                className="text-dark text-center"
                                colSpan="2"
                              ></td>
                            </>
                          )}
                        </tr>
                      </tfoot>
                    ) : null}
                  </table>
                  {/* {totalPage && totalPage > 0? ( */}
                  <Pagination
                    count={totalPage}
                    onChange={handleChange}
                    className={classes.pagination}
                  />
                  {/* ) : null} */}
                </div>
              ) : null}
              {details.length > 0 ? (
                <div className="table-responsive-sm mx-2">
                  <table className="table table-sm table-hover table-bordered">
                    <thead className="text-center thead-dark">
                      <tr>
                        <th scope="col" colSpan={type !== 'Comm' ? 8 : 7}>
                          {detailUsername} Details [
                          {moment(startDate).format('DD/MMM/YYYY') +
                            ' - ' +
                            moment(endDate).format('DD/MMM/YYYY')}
                          ]
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Day</th>
                        <th scope="col">Currency</th>
                        <th scope="col">Beginning</th>
                        {type !== 'Comm' ? (
                          <>
                            <th scope="col">Net W/L</th>
                            {/* <th scope="col">Gross Comm</th> */}
                            <th scope="col">Deposit</th>
                            <th scope="col">Withdraw</th>
                            <th scope="col">Balance</th>
                          </>
                        ) : (
                          <>
                            <th scope="col">Gross Comm</th>
                            <th scope="col">Withdraw</th>
                            <th scope="col">Balance</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {details.map((info, index) => (
                        <tr key={index}>
                          <td className="text-dark text-center">
                            {moment(info.reportDate).format('DD-MM-YYYY')}
                          </td>
                          <td className="text-dark text-center">
                            {moment(info.reportDate).format('ddd')}
                          </td>
                          <td className="text-dark text-center">
                            {info.currency}
                          </td>

                          {type !== 'Comm' ? (
                            <>
                              <td
                                className={`${
                                  info.beginning < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.beginning ? info.beginning.toFixed(2) : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.netWinLose < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.netWinLose ? info.netWinLose : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.deposit < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.deposit ? info.deposit : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.withdraw < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.withdraw ? info.withdraw : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.balance < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.balance ? info.balance : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                className={`${
                                  info.beginning < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.beginning ? info.beginning.toFixed(2) : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.winCommission < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={
                                    info.winCommission ? info.winCommission : 0
                                  }
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.withdraw < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.withdraw ? info.withdraw : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                              <td
                                className={`${
                                  info.balance < 0 ? 'text-danger ' : ''
                                }text-right`}
                              >
                                <CurrencyFormat
                                  value={info.balance ? info.balance : 0}
                                  decimalScale={2}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="text-dark text-center" colSpan="4">
                          Total
                        </td>
                        {type !== 'Comm' ? (
                          <>
                            <td
                              className={`${
                                totalWl < 0 ? 'text-danger ' : ''
                              }text-right`}
                            >
                              <CurrencyFormat
                                value={totalWl}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </td>
                            <td
                              className={`${
                                totalDep < 0 ? 'text-danger ' : ''
                              }text-right`}
                            >
                              <CurrencyFormat
                                value={totalDep}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </td>
                            <td
                              className={`${
                                totalWd < 0 ? 'text-danger ' : ''
                              }text-right`}
                            >
                              <CurrencyFormat
                                value={totalWd}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </td>
                            <td></td>
                          </>
                        ) : (
                          <>
                            <td
                              className={`${
                                totalComm < 0 ? 'text-danger ' : ''
                              }text-right`}
                            >
                              <CurrencyFormat
                                value={totalComm}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </td>
                            <td
                              className={`${
                                totalWd < 0 ? 'text-danger ' : ''
                              }text-right`}
                            >
                              <CurrencyFormat
                                value={totalWd}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </td>
                            <td></td>
                          </>
                        )}
                      </tr>
                    </tfoot>
                  </table>
                </div>
              ) : null}
              <Cash
                type={cashType}
                cashModal={cashModal}
                setCashModal={setCashModal}
                username={selected}
                refresh={handleChange}
              />
              <DepWd
                type={depositType}
                depositModal={depositModal}
                setDepositModal={setDepositModal}
                username={selected}
                refresh={handleChange}
              />
              <CommWd
                type={commType}
                depositModal={commModal}
                setDepositModal={setCommModal}
                username={selected}
                refresh={handleChange}
              />
            </>
          ) : tab === 1 ? (
            <>
              {renderDateSearch(true)}
              <CreditLogM
                startDate={startDate}
                endDate={endDate}
                id={memberId.current}
                setTab={setTab}
                tp={'members'}
                page={'cashLog'}
              />
            </>
          ) : tab === 2 ? (
            <>
              {renderDateSearch(true)}
              <CreditLogM
                startDate={startDate}
                endDate={endDate}
                id={memberId.current}
                setTab={setTab}
                tp={'agents'}
                page={'cashLog'}
              />
            </>
          ) : tab === 3 ? (
            <>
              {renderDateSearch(true)}
              {/* <button
            className="btn btn-sm btn-primary px-1 py-1 my-2 mx-2"
            onClick={() => {
              setTab(0);
            }}
          >
            Return
          </button> */}
              <Details
                transactions={transactions}
                handleChange={showMore}
                totalAmount={totalTransactions}
                totalPage={totalPage}
              />
            </>
          ) : tab === 4 ? (
            <>
              <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
                <button
                  className="btn btn-sm btn-secondary px-3 py-1"
                  onClick={() => {
                    setTab(0);
                  }}
                >
                  Return
                </button>
              </div>
              <div className="table-responsive-sm mx-2">
                <BetList
                  detailType={username}
                  startDate={startDate}
                  endDate={endDate}
                  username={User.username}
                  bets={bets}
                  handleChange={showOutstanding}
                  playerWager={playerWager}
                  totalTurnover={playerTurnover}
                  totalComm={playerComm}
                  agent={'Y'}
                  playerWinning={0}
                  totalPage={totalPage}
                  type={'OUTSTANDING'}
                />
              </div>
            </>
          ) : tab === 5 ? (
            <>
              <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
                <button
                  className="btn btn-sm btn-secondary px-3 py-1"
                  onClick={() => {
                    setTab(0);
                  }}
                >
                  Return
                </button>
              </div>
              <div className="table-responsive-sm mx-2">
                {/* The period total covers both sources, so it is shown in either segment - and it
                    sits above the control, because it is what the segment does not change. The sports
                    table's own total row is sports-only and is suppressed here rather than shown
                    beside it: two rows both labelled a total would be worse than one wrong one.

                    It is not shown when a column opened this list. That figure is the member's whole
                    period over both sources - the row that reconciles against the total's own click,
                    and no part of it - so above a column's rows it would be the previous figure still
                    on screen: the last total opened, for another member or another date range, left
                    there because this path never reads one. (On the Comm screen it is a Net W/L total
                    above commission rows as well: grandTotal is read without tx.) The line above the
                    list already says these tickets are not that figure. */}
                {netwlScope ? null : <BalanceGrandTotal total={grandTotal} />}
                {/* The number counts both sources; the list behind it used to hold the sports half
                    only, so a games-only member opened an empty list beside a non-zero number. Two
                    calls, one per source, each labelled with its own count.

                    A segment with no rows is not offered at all (Andrew, 2026-09-22): the count in its
                    label would read "(0)" and all it opens is an empty list. The effect above already
                    opens the first segment that has rows, so hiding one cannot leave a blank list on
                    screen - and when no segment has rows there is nothing to switch between, so the
                    strip goes too and the list below keeps its own "No bet history". */}
                {netwlScope ? (
                  <div className="mb-2 text-muted small">
                    The rows behind <b>{netwlScope.name}</b> for this member. These are the
                    tickets&apos; own figures - the player&apos;s stakes and winnings - so they do
                    not add up to the agent-level figure that was clicked.
                  </div>
                ) : null}
                {!netwlScope && (sportsCount > 0 || wegaSportCount > 0 || wegaCount > 0) ? (
                  <div className="segment-toggle">
                    {sportsCount > 0 ? (
                      <button
                        type="button"
                        className={netwlSegment === 0 ? 'active' : ''}
                        onClick={() => setNetwlSegment(0)}
                      >
                        Sports ({sportsCount})
                      </button>
                    ) : null}
                    {wegaSportCount > 0 ? (
                      <button
                        type="button"
                        className={netwlSegment === 1 ? 'active' : ''}
                        onClick={() => setNetwlSegment(1)}
                      >
                        WeGa sport ({wegaSportCount})
                      </button>
                    ) : null}
                    {wegaCount > 0 ? (
                      <button
                        type="button"
                        className={netwlSegment === 2 ? 'active' : ''}
                        onClick={() => setNetwlSegment(2)}
                      >
                        Games ({wegaCount})
                      </button>
                    ) : null}
                  </div>
                ) : null}
                {netwlSegment === 0 ? (
                  <BetList
                    showGrandTotal={false}
                    detailType={username}
                    bets={bets}
                    startDate={startDate}
                    endDate={endDate}
                    username={User.username}
                    handleChange={showNetwl}
                    playerWager={playerWager}
                    totalTurnover={playerTurnover}
                    totalComm={playerComm2}
                    agent={'Y'}
                    playerWinning={playerWinning}
                    totalPage={totalPage}
                  />
                ) : netwlSegment === 1 ? (
                  <WegaBetList
                    bets={wegaSportBets}
                    handleChange={showNetwlWegaSport}
                    totalPage={wegaSportTotalPage}
                    amountTotal={wegaSportAmount}
                    turnoverTotal={wegaSportTurnover}
                    commissionTotal={wegaSportComm}
                    winningTotal={wegaSportWinning + wegaSportComm}
                    tradeDetailUrl="agent/balanceReport/wega/tradeDetail"
                  />
                ) : (
                  <WegaBetList
                    bets={wegaBets}
                    handleChange={showNetwlGames}
                    totalPage={wegaTotalPage}
                    amountTotal={wegaAmount}
                    turnoverTotal={wegaTurnover}
                    commissionTotal={wegaComm}
                    winningTotal={wegaWinning + wegaComm}
                    tradeDetailUrl="agent/balanceReport/wega/tradeDetail"
                  />
                )}
              </div>
            </>
          ) : tab === 6 ? (
            <>
              {renderDateSearch()}
              <CreditLogM
                startDate={startDate}
                endDate={endDate}
                id={memberId.current}
                setTab={setTab}
                tp={'members'}
                page={'grossComm'}
              />
            </>
          ) : tab === 7 ? (
            <>
              {renderDateSearch()}
              <CreditLogM
                startDate={startDate}
                endDate={endDate}
                id={memberId.current}
                setTab={setTab}
                tp={'agents'}
                page={'grossComm'}
              />
            </>
          ) : null}
        </>
      )}
      {processing && (
        <>
          <br />
          <img
            src={require('../../img/loadingAnimation.gif')}
            height={13}
            width={208}
            alt=""
          />
        </>
      )}
    </>
  );
};

export default WinLose;
